'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapPropsAndThemeToStyle = exports.defaultStyle = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _objectResolvePath = require('object-resolve-path');

var _objectResolvePath2 = _interopRequireDefault(_objectResolvePath);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaultStyle = exports.defaultStyle = {
  '& *': {
    boxSizing: 'border-box'
  },
  '&.toggle': {},
  '& .switch': {
    position: 'relative',
    cursor: 'pointer'
  },
  '& .switch.disabled': {
    cursor: 'not-allowed'
  },
  '& .toggle-label-wrap': {
    display: 'flex',
    position: 'relative'
  },
  '& .toggle-label-wrap, & .toggle-switch': {
    border: '1px solid black',
    borderRadius: '5px'
  },
  '& .toggle-label': {
    flex: 1,
    textAlign: 'center'
  },
  '& .switch, & .toggle-switch': {
    borderRadius: '4px',
    lineHeight: '36px'
  },
  '& .toggle-label, & .toggle-switch': {
    padding: '0 15px'
  },
  '& .toggle-switch': {
    backgroundColor: '#fff',
    height: '100%',
    left: 0,
    overflow: 'hidden',
    position: 'absolute',
    textAlign: 'center',
    top: 0,
    transform: 'translate(0%, 0)',
    transition: 'all 200ms ease-in-out',
    width: '50%'
  },
  '& .switch.on .toggle-switch': {
    transform: 'translate(100%, 0)'
  },
  '& .content': {
    height: '100%',
    position: 'absolute',
    left: 0,
    top: 0,
    transition: 'opacity 200ms ease-in-out',
    width: '100%'
  },
  '& .switch.off .content.on, & .switch.on .content.off': {
    opacity: 0
  },
  '& .switch.on .content.on, & .switch.off .content.off': {
    opacity: 1
  }
};

var mapPropsAndThemeToStyle = exports.mapPropsAndThemeToStyle = function mapPropsAndThemeToStyle(props, theme) {
  return (0, _extends3.default)({
    '& .toggle-label-wrap.toggle-label-wrap': {
      borderColor: theme.colors.disabled
    },
    '& .toggle-label': {
      color: theme.colors.disabled
    },
    '& .toggle-switch': {
      borderColor: theme.colors.primary,
      color: theme.colors.primary
    }
  }, (0, _objectResolvePath2.default)(theme, 'Toggle.css') || {});
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@nike/ruxac/components/form/Toggle/Toggle.style.js
// module id = 612
// module chunks = 0